import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDFRcEG2DcXsGxtnRAfh-KCmzCHe1l-hno",
  authDomain: "traveltimetoxplore-fd084.firebaseapp.com",
  projectId: "traveltimetoxplore-fd084",
  storageBucket: "traveltimetoxplore-fd084.firebasestorage.app",
  messagingSenderId: "47311705035",
  appId: "1:47311705035:web:7fb2716af43ac544ae9c4e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;